import styled from "@emotion/styled";
import { border } from "@smartsheet/design-tokens";
import { RequiredThemeKeys } from "../../../util/theme";
import { checkboxBorderTheme } from "../checkboxTheme";

const getSize = (props: CheckboxWrapperProps) => props.size;

interface CheckboxWrapperProps {
    size: 16 | 20;
    themeMode: RequiredThemeKeys;
}

export const CheckmarkWrapper = styled("div")<CheckboxWrapperProps>`
    // border color is managed from the CheckboxIcon component.
    border-width: ${border.width20};
    border-style: solid;
    border-radius: ${({ themeMode }) => checkboxBorderTheme.borderRadius(themeMode)};

    box-sizing: border-box;
    height: ${getSize}px;
    width: ${getSize}px;

    flex: none;
`;

CheckmarkWrapper.displayName = "CheckboxWrapper";
